module.exports = __webpack_public_path__ + "img/safari-permit.cae2186.png";